import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineChevronLeft, HiOutlineExclamationCircle } from 'react-icons/hi';
import { useAuth } from '../../context/AuthContext';
import { hasCardAction } from '../../utils/permissionHelper';
import axiosInstance from '../../api/axiosConfig';
import UploadTab from './components/UploadTab';
import EmployeesTab from './components/EmployeesTab';
import BatchesTab from './components/BatchesTab';
import './PayslipDistribution.css';

const CARD = 'payslip-distribution';

const PayslipDistribution = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState('upload');
    const [gateway, setGateway] = useState(null);

    const permissions = user?.permissions || { cards: [], actions: [] };
    const isAdmin = user?.role === 'system_admin';
    const canCreate = isAdmin || hasCardAction(permissions, CARD, 'create');
    const canEdit = isAdmin || hasCardAction(permissions, CARD, 'edit');
    const canDelete = isAdmin || hasCardAction(permissions, CARD, 'delete');
    // Dispatching is gated on `approve` so uploading a payroll run does not by
    // itself let someone broadcast everyone's salary.
    const canSend = isAdmin || hasCardAction(permissions, CARD, 'approve');

    useEffect(() => {
        // Surface WhatsApp misconfiguration up front rather than at send time.
        axiosInstance
            .get('/api/payslips/gateway-status')
            .then((res) => setGateway(res.data?.data || null))
            .catch(() => setGateway(null));
    }, []);

    const tabs = [
        { id: 'upload', label: 'Upload & Send', icon: '📤' },
        { id: 'batches', label: 'History', icon: '🗂️' },
        { id: 'employees', label: 'Employee Master', icon: '👥' }
    ];

    return (
        <div className="pd-shell">
            <header className="pd-header">
                <div className="pd-header-left">
                    <button className="pd-back-btn" onClick={() => navigate('/purpose-selection')}>
                        <HiOutlineChevronLeft size={20} />
                    </button>
                    <div className="pd-header-title">
                        <h1>Payslip Distribution</h1>
                        <span>WhatsApp</span>
                    </div>
                </div>
            </header>

            {gateway && !gateway.ready && (
                <div className="pd-banner pd-banner-warn">
                    <HiOutlineExclamationCircle size={18} />
                    <div>
                        <strong>WhatsApp is not ready.</strong> {gateway.reason}
                        <div className="pd-banner-sub">
                            Uploading and reviewing still works — only sending is blocked.
                        </div>
                    </div>
                </div>
            )}

            <nav className="pd-nav">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`pd-nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <span className="pd-nav-tab-icon">{tab.icon}</span>
                        {tab.label}
                    </button>
                ))}
            </nav>

            <div className="pd-body">
                <main className="pd-content">
                    {activeTab === 'upload' && (
                        <UploadTab canCreate={canCreate} canSend={canSend} gatewayReady={gateway?.ready} />
                    )}
                    {activeTab === 'batches' && (
                        <BatchesTab canSend={canSend} canDelete={canDelete} gatewayReady={gateway?.ready} />
                    )}
                    {activeTab === 'employees' && (
                        <EmployeesTab canCreate={canCreate} canEdit={canEdit} canDelete={canDelete} />
                    )}
                </main>
            </div>
        </div>
    );
};

export default PayslipDistribution;
